export default __webpack_public_path__ + "images/avatar-placeholder.e9ed0bd5829bb8815fa530b8592b5a58.png";